module.exports = __webpack_public_path__ + "img/03.f64b073e.png";